import {useState, useContext} from 'react';
import {Link} from "react-router-dom"
import {UserContext, UpdateUserContext} from "../../App"
import {Cookies} from "react-cookie"
import {message_to_users} from "../Fonctions"
import {tab_color} from "../config/Config"


export function Gestion () {

  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)

  const cook = new Cookies();
  let auth = {    
    nom:cook.get("nom"),
    prenom:cook.get("prenom"),
    mdp:cook.get("mdp"),
  }

  const [modal, setModal] = useState('')
  const [field, setField] = useState({
    creer_eleve:'',
    creer_groupe:'',
    suppr_compte:'',
    suppr_groupe:'',
    current_classe:'',
    gen_mdp:'',
    mdp:'',
    mdp_new:'',
    mdp_new_confirm:'',
    modif_mdp:'',
    classe_to_share:'',
    num_classe_to_share:'',
  })
  
  const [msg, setMsg] = useState({
    creer_eleve:'',
    creer_groupe:'',
    suppr_compte:'',
    suppr_groupe:'',
    gen_mdp:'',
    modif_mdp:'',
    share_classe:'',
  })
  const tab = []

  const dl_info = (field) => {
    let csv = document.querySelector('.info').innerText.slice(203,-35)+"\n\n"
    let a = document.getElementById("dl_mdp")
    a.href = "data:text/csv;base64," + btoa(csv)
  }
  const handleChange = (e) => {
    setField({...field, [e.target.name]:e.target.value})
  }
  const handleClick = (e) => {
    const name = e.target.attributes.name.nodeValue
    switch (name) {
      case 'modif_mdp':
        e.target.remove()
        setMsg({...msg, aff_mofif_mdp:true})
        break;
      default:
        auth = {...auth, current_classe:name}
        setField({...field, current_classe:name})
        e.target.parentNode.querySelector('.active')?.classList.toggle('active')
        e.target.classList.toggle('active')
    }
  }

  const cleanMsg = (name) => {
    setTimeout(e => {
          if(name !== "creer_eleve") {setMsg({...msg, [name]:''})}
        }, 5000)
  }

  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    let field_content = field[name]
    if (( !'modif_mdp_share_classe'.includes(name) && !field_content) 
          || (name === 'modif_mdp' && (!field.mdp || !field.mdp_new || !field.mdp_new_confirm))
          || (name === 'share_classe' && (!field.classe_to_share || !field.num_classe_to_share))
          ) {
      setMsg({...msg, [name]:'<div class="alert danger fadeout5"><br>Veuillez remplir le champ...<br><br></div>'})
      cleanMsg(name)
      return
    }
    if(name === 'modif_mdp') {
      field_content = [field.mdp, field.mdp_new, field.mdp_new_confirm]
    }
    if(name === 'share_classe') {
      field_content = [field.classe_to_share, field.num_classe_to_share]
    }
    auth = {...auth, action:name, field:field_content, current_classe:field.current_classe}
    setField({...field, [name]:'', current_classe:''})

    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      setModal(data)
      setMsg({...msg, [name]:data})
      if(name !== "creer_eleve") {cleanMsg({...msg, [name]:''})}
      if(name === "creer_eleve") {
        //console.log(e.target.parentNode)
        //e.target.parentNode.querySelector('.active')?.classList.remove('active')
      } else {e.target.previousElementSibling.value = ''}
      
      updateUsercontext(name)
      //updateUser(name)
    })
    .catch(err => console.log(err))    
  }


  let color_classe = {}
  let k = 0
  user.liste_classes?.forEach(c => {
    color_classe = {...color_classe, [c]:tab_color[k]}
    k++
  })

  if (user.mes_classes) {
    Object.keys(user.mes_classes)?.forEach(classe => {
      user.mes_classes[classe].forEach(eleve => {
        tab.push(eleve)
      })
    })

    tab.sort((a, b) => {
      const date1 = new Date(a.ddc)
      const date2 = new Date(b.ddc)
      return date2 - date1 || a.classe1 === b.classe1;
    })
  }

  
  return (
    <div>
      <h1>Espace professeur</h1>

      {
        msg.creer_eleve ? 
        <div className="info">
          <span dangerouslySetInnerHTML={{ __html:msg.creer_eleve}}></span>
          <b>Sauvegarder</b> les identifiants : <a style={{cursor:'pointer'}} id="dl_mdp" onClick={()=>dl_info(field)}> 📁 </a><br/><br/>
        </div>
        : ''
      }

      {
        message_to_users()
      }

    	{
        user.liste_classes.length ? 
        <div className="content" style={{float:"left"}} >
          <h1>Créer des comptes élève</h1>
          <textarea name="creer_eleve" id="liste_eleves" style={{width:"70%",height:"360px"}} placeholder="Copiez-collez ici la liste sous la forme : &#13; &#13; Nom Prénom &#13; Nom Prénom  &#13; Nom Prénom  &#13; Nom Prénom  &#13; Nom Prénom  &#13; ... &#13; &#13; Vérifiez que les noms ou prénoms composés soient reliés par un trait d'union (sinon, seule la première particule sera retenue dans l'identifiant). &#13; Par exemple Le-Marchand Jean-Steeve  " cols="30" rows="10" onChange={handleChange} value={field.creer_eleve}></textarea>
          <br/><br/>
          Choisir une classe dans laquelle affecter les élèves :<br/>
          {user.liste_classes?.map((classe, k) => <span key={k} className="btn_param" name={classe} onClick={handleClick} title={'incrire les élèves en '+classe} >{classe}</span>)}
          <br/>
          {field.current_classe ? <input type="button" className="btn_standard" name="creer_eleve" id="creer_eleve" value={'Inscrire les élèves en '+field.current_classe} onClick={handleSubmit} style={{width:'50%', padding:'5px', color:'#314159'}} /> :''}
        </div> : ''
      }

      <div className="content">
        <h1>Créer un groupe / classe</h1>
        <input type="text" name="creer_groupe" placeholder="nom du groupe/classe" onChange={handleChange} />
        <input type="button" name="creer_groupe" className="btn standard" value="Créer" onClick={handleSubmit} />
        {msg.creer_groupe ? <span dangerouslySetInnerHTML={{ __html:msg.creer_groupe}}></span> : ''}
      </div>

      <div className="content">
        <h1>Supprimer un compte</h1>
        <input type="text" name="suppr_compte" placeholder="prenom.nom" onChange={handleChange} />
        <input type="button" name="suppr_compte" className="btn standard" value="Supprimer" onClick={handleSubmit} />
        {msg.suppr_compte ? <span dangerouslySetInnerHTML={{ __html:msg.suppr_compte}}></span> : ''}
      </div>
      
      <div className="content">
        <h1>Supprimer une classe</h1>
        <input type="text" name="suppr_groupe" placeholder="nom du groupe/classe" onChange={handleChange} />
        <input type="button" name="suppr_groupe" className="btn standard" value="Supprimer" onClick={handleSubmit} />
        {msg.suppr_groupe ? <span dangerouslySetInnerHTML={{ __html:msg.suppr_groupe}}></span> : ''}
      </div>
      
      <div className="content">
        <h1>Réinitialiser un mot de passe élève</h1>
        <input type="text" name="gen_mdp" placeholder="prenom.nom" onChange={handleChange} />
        <input type="button" name="gen_mdp" className="btn standard" value="Générer" onClick={handleSubmit} />
        {msg.gen_mdp ? <span dangerouslySetInnerHTML={{ __html:msg.gen_mdp}}></span> : ''}
      </div>

      <div className="content max">
        <h1>Dernières connexions</h1>
        <div className="col_4" >
        {tab.map(eleve =>  
          <span key={eleve.id} style={{color:color_classe[eleve.classe1]}} title={eleve.prenom+' '+eleve.nom+' connecté.e le '+eleve.ddc.slice(-2)+'/'+eleve.ddc.slice(5,-3)} > 
          {eleve.prenom} {eleve.nom[0]} ({eleve.ddc.slice(-2)}/{eleve.ddc.slice(5,-3)} {eleve.classe1})
          <br/></span>)}
        </div>
      </div>

      <div className="content">
        <h1>Mon compte</h1>
        Votre identifiant est : <b>{user.prenom}.{user.nom}</b>
        <br/><br/>
        Numéro d'identification : 20-{user.id}-22
        <br/><br/>
        Modifier mon mot de passe : <br/>
        <span className={msg.aff_mofif_mdp ? 'modif_mdp active' : 'modif_mdp' } >
          <input type="password" name="mdp" placeholder="ancien mot de passe" onChange={handleChange} /><br/>
          <input type="password" name="mdp_new" placeholder="nouveau mot de passe" onChange={handleChange}/><br/>
          <input type="password" name="mdp_new_confirm" placeholder="confirmer mot de de passe" onChange={handleChange}/><br/>
          <input type="button" name="modif_mdp" className="btn_standard" value="Envoyer" onClick={handleSubmit} />
        </span>
        <input type="button" name="modif_mdp" className="btn_standard" value="Modifier" onClick={handleClick} />
        {msg.modif_mdp ? <span dangerouslySetInnerHTML={{ __html:msg.modif_mdp}}></span> : ''}
        <br/><br/>
        Vous pouvez demander une suppression de votre compte en cliquant ici <br/> <a href="https://maths-au-quotidien.fr/contact.php#suppr_compte"> <img src="https://maths-au-quotidien.fr/images/automaths/dell_count.png" alt="suppimer compte" height="30"/></a>
        <br/><br/>
        {
          user.id == 1 &&
          <Link to={'/compteConfig'}>
            <input type="button" className="btn_standard" value="Configurer"/>
          </Link>
        }
      </div>

      <div className="content">
        <h1>Partager une classe</h1>
        Si vous souhaitez partager une classe avec un autre utilisateur Automaths (un maximum), vous devez lui transmettre la clé suivante :  
        <br/><br/>
        <div style={{color:"steelblue", wordBreak: "break-all"}}><b>{user.cle_partage} </b></div>
        <br/>
        Si vous disposez d'une clé (transmise par un utilisateur Automaths), merci de compléter les champs suivants :
        <br/> 
        <input type="text" name="classe_to_share" placeholder="Nom de la classe à récupérer" style={{width:"100%"}} onChange={handleChange} />
        <br/><br/>
        <input type="text" name="num_classe_to_share" placeholder="Clé transmise par un utilisateur" style={{width:"100%"}} onChange={handleChange} />
        <input type="button" name="share_classe" className="btn_standard" value="Récupérer le groupe" onClick={handleSubmit} />
        <br/>
        {msg.share_classe ? <span dangerouslySetInnerHTML={{ __html:msg.share_classe}}></span> : ''}
      </div>

      <br />
    </div>
  );
}